import { FC } from 'react';
import { formatNum } from '@app/utils/math';
import clsx from 'clsx';

interface IProgressBarProps {
  percent: number;
  label?: string;
  descriptionColor?: string;
  labelSize?: string;
  fillerColor: string;
  description?: string;
  totalLabel?: number;
  totalLabelColor?: string;
  className?: string;
  backgroundColor?: string;
}

const ProgressBar: FC<IProgressBarProps> = ({
  percent,
  label,
  labelSize = '28px',
  descriptionColor,
  fillerColor,
  description,
  totalLabel,
  totalLabelColor,
  className,
  backgroundColor = '#211F24',
}) => {
  return (
    <div
      className={clsx(
        'relative flex justify-center items-center w-full rounded-[8px]',
        className || 'h-[41px]'
      )}
      style={{ backgroundColor }}
    >
      {description ? (
        <span
          style={{ color: descriptionColor }}
          className="absolute left-[10px] text-[16px] z-[1]"
        >
          {description}
        </span>
      ) : null}
      <div
        className={`absolute left-0 h-full rounded-[8px]`}
        style={{ backgroundColor: fillerColor, width: (percent > 100 ? '100' : percent) + '%' }}
      ></div>
      {label && <span className={`text-[${labelSize}] z-[1]`}>{label}</span>}
      {totalLabel ? (
        <span
          style={{ color: totalLabelColor }}
          className={`absolute right-[10px] text-[16px] z-[1]`}
        >
          {formatNum(totalLabel)} Ph
        </span>
      ) : null}
    </div>
  );
};

export default ProgressBar;
